'use client';

import { useSavedRecipes } from '@hooks/recipe/useSavedRecipes';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import SavedRecipeCard from './_SavedRecipeCard';

interface SavedRecipesProps {
  title?: string;
}

const SavedRecipes = ({ title }: SavedRecipesProps) => {
  const { t } = useTranslation();
  const { data: savedRecipes } = useSavedRecipes();

  const hasLoaded = savedRecipes !== undefined;

  if (!hasLoaded) {
    return (
      <div className="px-6 py-8" data-testid="saved-recipes-loading">
        {title && <h2 className="mb-6 tra-text-web-sub-1">{title}</h2>}
        <div className="grid max-w-5xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="animate-pulse">
              <div className="bg-neutral-200 aspect-[4/3] w-full" />
              <div className="mt-4 space-y-2">
                <div className="w-3/4 h-5 bg-neutral-200" />
                <div className="w-1/2 h-4 bg-neutral-200" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!savedRecipes?.length) {
    return (
      <div className="px-6 py-12 text-center" data-testid="saved-recipes-empty">
        {title && <h2 className="mb-6 tra-text-web-sub-1">{title}</h2>}
        <p className="tra-text-web-body-l text-neutral-500">
          {t('savedRecipes.empty', undefined, { default: 'You have no saved recipes yet.' })}
        </p>
      </div>
    );
  }

  return (
    <div data-testid="saved-recipes">
      {title && <h2 className="mb-6 tra-text-web-sub-1">{title}</h2>}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {savedRecipes.map((item) => (
          <SavedRecipeCard key={item.contentId} item={item} />
        ))}
      </div>
    </div>
  );
};

export default SavedRecipes;
